import React, { Component } from 'react';
import { Modal,Form,Input,Row,InputNumber,Switch,DatePicker,Select,Divider,Col,Button,Icon,Upload } from 'antd';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';
import moment from 'moment';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import server from '../../../axios/server'


const fields = [ 
    {
        "text": "检验日期",
        "field": "createTime",
        "date": true
    }
    , {
        "text": "检验报告编号",
        "field": "reportNo"
    }
    , {
        "text": "号牌号码",
        "field": "plateNo",
        rules: [
            { required: true, message: '号牌号码不能为空!' },
        ]
    }
    , {
        "text": "品牌",
        "field": "brand",
        rules: [
            { required: true, message: '品牌不能为空!' },
        ]
    }
    , {
        "text": "型号",
        "field": "model",
        rules: [
            { required: true, message: '型号不能为空!' },
        ]
    }
    , {
        "text": "车辆识别代号",
        "field": "vin",
        rules: [
            { required: true, message: '车辆识别代号不能为空!' },
        ]
    }
    , {
        "text": "发动机号码",
        "field": "engineNo",
        rules: [
            { required: true, message: '发动机号码不能为空!' },
        ],
    }
    , {
        "text": "车辆类型",
        "field": "vehicleType",
        rules: [
            { required: true, message: '车辆类型不能为空!' },
        ],
    }
    , {
        "text": "出厂日期",
        "field": "produceDate",
        date:true,
        rules: [
            { required: true, message: '出厂日期不能为空!' },
        ],
    }
    , {
        "text": "生产厂家",
        "field": "produceCompany",
        rules: [
            { required: true, message: '生产厂家不能为空!' },
        ],
    }
    , {
        "text": "里程",
        "field": "mileage",
        rules: [
            { required: true, message: '里程不能为空!' },
        ],
    }
    , {
        "text": "有效期至",
        "field": "expirationDate",
        date:true,
        rules: [
            { required: true, message: '有效期不能为空!' },
        ],
    }
    , {
        "text": "委托人",
        "field": "principal",
        select: true,
        dictList: [{
            code: 1,
            name: '厦门现代通商汽车服务有限公司'
        }
        ,{
            code: 2,
            name: '长江汽车产业供应链有限公司'
        }
        ,{
            code: 3,
            name: '厦门联联车信息科技有限公司'
        }
    ],
        rules: [
            { required: true, message: '委托人不能为空!' },
        ],
    }
    , {
        "text": "检测师签字",
        "field": "inspector",
        select: true,
        dictList: [{
            code: 1,
            name: '吴金改'
        }
        ,{
            code: 3,
            name: '叶惠坤'
        }
        ,{
            code: 5,
            name: '林亚斌'
        }
        ,{
            code: 6,
            name: '王振治'
        }
        ,{
            code: 7,
            name: '黄晓鹏'
        }
    ]
    }
    , {
        "text": "报告类型选择",
        "field": "type",
        select: true,
        dictList: [{
            code: 1,
            name: '乘用车'
        },{
            code: 2,
            name: '商用车'
        }],
        rules: [
            { required: true, message: '报告类型选择不能为空!' },
        ],
    }
    , {
        "text": "是否展示二维码",
        "field": "showQr",
        radio: true
    }
];


class ExportCheckReportEditForm extends Component {
    state = {
        //照片
        otherImagesUrl: [],
        otherImage: [],
        imageList: [],
        url: '',
        fileList: []
    }

    componentDidMount() {
        if (this.props.initFunc) {
            this.props.initFunc(this.initEdit);
        }
        if (this.props.initFile) {
            this.props.initFile(this.initFile);
        }

        let url = '';
        url = server.httpServerUrl + '/exportCheckReport/uploadFile'
        this.setState({
            url: url,
        });
        let clientW = document.body.clientWidth
        let clientH = document.body.clientHeight
        this.setState({
            clientW: clientW,
            clientH: clientH
        })
    }

    initEdit = (editData) => {
        let otherImages = editData.otherImages;
        let otherImagesUrl = [];
        let otherImage = [];
        if (otherImages != null && otherImages.length > 0) {
            for (let index in otherImages) {
                if (otherImages[index] != null && otherImages[index] !== "") {
                    otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
                }
            }
            otherImagesUrl = editData.otherImagesUrl;
        }
        this.setState({otherImage: otherImage, otherImagesUrl: otherImagesUrl });
    }

    initFile = (fileData) => {
        if (fileData.pdffileList !== undefined) {
            let fileList = [];
            for (let i = 0; i < fileData.pdffileList.length; i++) {
                fileList.push({
                    uid: fileData.pdffileList[i].id,
                    name: fileData.pdffileList[i].fileName,
                    url: server.httpServerUrl + '/exportCheckReport/downloadFile?url=' + encodeURI(fileData.pdffileList[i].fileUrl),
                    status: 'done',
                })
            }
            this.setState({
                fileList: fileList
            })
        }else{
            this.setState({
                fileList: []
            })
        }
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            let url='/exportCheckReport/save'
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
                url='/exportCheckReport/update'
            }
            let code = this.props.editData.code
            if (code !== undefined && code != null) {
                values["code"] = code;
            }
            fields.forEach((json, index) => {
                if (json["radio"] === true) {
                    values[json["field"]] = values[json["field"]] ? 1 : 0;
                }
            })
            if (values["createTime"] != null) {
                values["createTime"] = values["createTime"].format("yyyy-MM-DD HH:mm:ss");
            }
            if (values["produceDate"] != null) {
                values["produceDate"] = values["produceDate"].format("yyyy-MM-DD");
            }
            if (values["expirationDate"] != null) {
                values["expirationDate"] = values["expirationDate"].format("yyyy-MM-DD");
            }
            let other = [];
            let otherImage = this.state.otherImage;
            let otherImagesUrl = this.state.otherImagesUrl;
            for (let i = 0; i < this.state.otherImage.length; i++) {
                if (otherImagesUrl.length > i && otherImagesUrl[i] != null && otherImagesUrl[i] !== "") {
                    other.push(otherImagesUrl[i]);
                } else {
                    other.push(otherImage[i]);
                }
            }
            values["photos"] = JSON.stringify(other);
            http.post({
                url: url,
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: 
                            item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field])):
                            item.radio ? editData[item.field] === 1 : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.select ? <Select onSelect={this.onSelect.bind(this, item.field)} >
                                {item.dictList.map(d => <Select.Option key={d["code"]}>{d["name"]}</Select.Option>)}
                            </Select>:
                            item.date ?<DatePicker disabled={item.disabled === true} style={{ width: '100%' }} />:
                            item.number ?<InputNumber precision={1} min={0.0} max={999999999} style={{ width: '100%' }} />
                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                            : item.radio ?<Switch checkedChildren="是" unCheckedChildren="否" />:<Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    onSelect = (field, key) => {
        const { form } = this.props;
        form.setFieldsValue({
            field: key,
            "agentMan": ""
        });
    }
    //创建图片dom
    createOtherImageDom = () => {
        let dom = [];
        let data = this.state.otherImage;
        let otherImagesUrl = this.state.otherImagesUrl;
        for (let i = 0; i <= data.length; i++) {
            let file = data[i];
            let url = i < otherImagesUrl.length ? otherImagesUrl[i] : null;
            dom.push(
                <Col span={4} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, "otherImage")}
                        onChange={this.handleUploadImage.bind(this, "otherImage")}
                        onRemove={this.handleRemoveImage.bind(this, "otherImage", i)}
                        original={true}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }
    //上传图片
    handleUploadImage = (field, { base64 }) => {
        const list = this.state.otherImage;
        list.push(base64);
        this.setState({ "otherImage": list });   
    }
    //删除图片
    handleRemoveImage = (field, index) => {
        const list = this.state.otherImage;
        const otherImagesUrl = this.state.otherImagesUrl;
        list.splice(index, 1);
        otherImagesUrl.splice(index, 1);
        this.setState({ "otherImage": list, "otherImagesUrl": otherImagesUrl });
    }

    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };
    handleScan = (base64) => {
        if (base64 != null && base64 !== "") {
            base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
            if (this.state.imageField === "otherImage") {
                const list = this.state.otherImage;
                list.push(base64);
                this.setState({ "otherImage": list });
            } else {
                this.handleUploadImage(this.state.imageField, { base64 });
            }
        }
    }

    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                if (this.props.editData.pdffileList === undefined) {
                    this.props.editData.pdffileList = []
                }
                file.url = server.httpServerUrl + '/exportCheckReport/downloadFile?url=' + encodeURI(file.response.data[0].fileUrl);
                file.uid = file.response.data[0].id;
                file.id = file.response.data[0].id;
            }
            return file;
        });
        this.setState({ fileList });
    };

    remove = (info) => {
        let pdffileList = this.props.editData.pdffileList;
        for (let i = 0; i < this.props.editData.pdffileList.length; i++) {
            if (info.uid === this.props.editData.pdffileList[i].id) {
                pdffileList.splice(i, 1);
            }
        }
        http.post({
            url: '/exportCheckReport/deleteFile',
            data: { "id": info.uid },
            success: (res) => {
                messager.notify("删除成功！");
            },
            error: (res) => {
            }
        });

    }

    render() {
        const { visible, onCancel,editData } = this.props;
        return (
            <Modal
                visible={visible}
                title="出口检测报告编辑"
                width={800}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
            <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                <Row>{this.create2Col(fields)}</Row>
                <Row>
                    <Divider orientation="left">照片</Divider>
                    {this.createOtherImageDom()}
                </Row>
                <Row>
                    <Divider orientation="left" >上传附件</Divider>
                    <Upload
                        action={this.state.url}
                        onChange={this.handleChange}
                        multiple={true}
                        fileList={this.state.fileList}
                        data={{ id: editData.id }}
                        withCredentials={true}
                        // onDownload={this.downLoad}
                        onRemove={this.remove}
                        accept=".*"
                    >
                        <Button>
                            <Icon type="upload" /> 上传附件
                        </Button>
                    </Upload>
                </Row>
            </Form>
            <Scanner
                visible={this.state.visible}
                onCancel={this.hiddenModal.bind(this)}
                initScanner={(func) => { this.setState({ initScanner: func }) }}
                onScan={this.handleScan}
            />
            </Modal>
        );
    }
}

const ExportCheckReportEdit = Form.create()(ExportCheckReportEditForm);

export default ExportCheckReportEdit;